import RejectReasonBadge from 'domains/merchant-inbound-item-reject/atoms/reject-reason-badge'
import React from 'react'

/**
 * Merchant Inbound Item Reject Table Columns
 */
const merchantInboundItemRejectTableColumns = () => {

  const RejectReasonCell = (row) => <RejectReasonBadge reject_reason={ row.cell.value } />

  return (
    [
      {
        Header  : 'Reject Return Items',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header         : 'Inventory SKU',
            accessor       : 'item_reject.inventory_sku',
            disableFilters : true
          },
          {
            Header         : 'Product Info',
            accessor       : 'item_reject.product_info',
            disableFilters : true
          },
          {
            Header         : <>Reject <br/> Reason</>,
            accessor       : 'item_reject.reject_reason',
            Cell           : RejectReasonCell,
            disableFilters : true
          },
          {
            Header         : 'Reject Note',
            accessor       : 'item_reject.reject_note',
            disableFilters : true
          },
          {
            Header         : 'Rejected By',
            accessor       : 'item_reject.rejected_by.name',
            disableFilters : true
          }
        ]
      }
    ]
  )
}

export default merchantInboundItemRejectTableColumns